import React, { useEffect, useState } from "react"
import { Link }                       from "react-router-dom";
import shop                           from "shop/shop"

const ProductReplacementTile = ( { product } ) => {
  return <Link to={`/product/${product.map_id}`} className="db dim mh2 mb3 w-25">
    <div className="ba pa3 b--light-gray br3  ">
      <img src={product.img_src_small} alt={product.desc.des}/>
      <div className="b f6">{product.desc.map_id}</div>
      <div className="f7">{product.desc.short_des}</div>
    </div>
  </Link>
}

export default function ProductReplacementHints( { product } ) {
  const [products, setProducts] = useState( [] )
  if ( !product ) return null
  const { map_id } = product
  
  useEffect( () => {
    async function loadList() {
      if ( !product.extraValue.Ersatzartikel1 ) return
      const list = []
      // VOMIT-O-CODE
      if ( product.extraValue.Ersatzartikel1 ) list.push( product.extraValue.Ersatzartikel1 )
      if ( product.extraValue.Ersatzartikel2 ) list.push( product.extraValue.Ersatzartikel2 )
      if ( product.extraValue.Ersatzartikel3 ) list.push( product.extraValue.Ersatzartikel3 )
      if ( product.extraValue.Ersatzartikel4 ) list.push( product.extraValue.Ersatzartikel4 )
      if ( product.extraValue.Ersatzartikel5 ) list.push( product.extraValue.Ersatzartikel5 )
      if ( product.extraValue.Ersatzartikel6 ) list.push( product.extraValue.Ersatzartikel6 )
      if ( product.extraValue.Ersatzartikel7 ) list.push( product.extraValue.Ersatzartikel7 )
      if ( product.extraValue.Ersatzartikel8 ) list.push( product.extraValue.Ersatzartikel8 )
      if ( product.extraValue.Ersatzartikel9 ) list.push( product.extraValue.Ersatzartikel9 )
      if ( product.extraValue.Ersatzartikel10 ) list.push( product.extraValue.Ersatzartikel10 )
      if ( product.extraValue.Ersatzartikel11 ) list.push( product.extraValue.Ersatzartikel11 )
      const products = await shop.products.list( list )
      setProducts( products )
    }
    
    loadList()
    
  }, [map_id] )
  if ( products.length < 1 ) return null
  return <div>
    <div className="pt3 pt4-ns">
      <h4>{translate( "Ersatzartikel" )}</h4>
      <div className="pb1">{translate( "Für diesen Artikel existieren folgende Alternativen:" )}</div>
      <div className="flex flex-wrap flex-row na2 pv2">
        {products.map( p => {
          return <ProductReplacementTile key={p.map_id} product={p}/>
        } )}
      </div>
    </div>
  </div>
}


// WEBPACK FOOTER //
// ./src/components/Product/ProductReplacementHints.js